import { query } from 'sdi/shape';
import { fromNullable, none, Option, some } from 'fp-ts/lib/Option';
import { FeatureCollection } from 'sdi/source';
import { Either, left, right } from 'fp-ts/lib/Either';
import { getSelectedIssueIds } from './table';
import { getLinkedIssues, getThemes } from './qa';
import { fst, snd } from 'sdi/lib';

export const getLayout = () => query('app/layout');

export const getTheme = () => fromNullable(query('app/theme'));

export const getThemeObject = () =>
    getThemes().map(themes =>
        themes.find(t => t.slug === getTheme().getOrElse(''))
    );

export const withMapCompleteTheme = () =>
    fromNullable(
        getThemeObject().fold(undefined, theme => theme?.map_complete_theme)
    );

export const getUsername = () =>
    fromNullable(query('data/user')).map(u => u.name);

export const getCollapsible = (name: string) =>
    fromNullable(query('app/collapsible')[name]).getOrElse(false);

export const getRenderGlobalInfoBlock = () =>
    getSelectedIssueIds().length < 1 ? true : false;

export const getRenderGlobalDuration = () => query('app/global/info/duration');

export const getAutoZoom = () => query('app/issue/zoom/auto');
export const getAutoCenter = () => query('app/issue/center/auto');

export const getLinkChangeId = () =>
    fromNullable(query('app/linked/change/id'));

export const getChangeLinkGroup = () => {
    console.log(`CHANGE LINK GROUP!!! ${getLinkChangeId()}`);
    return getLinkChangeId().chain(id => getLinkedIssues(id));
};

export const getTextForm = () => fromNullable(query('qa/notes/form'));
export const getEditStatusBool = (key: string) =>
    fromNullable(query('app/text/edit'))
        .map(s => key === fst(s) && snd(s))
        .getOrElse(false);

export const getLayerData = (
    ressourceId: string
): Either<string, Option<FeatureCollection>> => {
    const layers = query('data/layers');
    const errors = query('remote/errors');
    if (ressourceId in layers) {
        return right(some<FeatureCollection>(layers[ressourceId]));
    } else if (ressourceId in errors) {
        return left(errors[ressourceId]);
    }
    return right(none);
};
export const getGlobalInfoDuration = () => query('app/global/info/duration');

export const getNewTextEdit = () => query('app/source/new/edit');
